module.exports = __webpack_public_path__ + "static/media/1.ee804b00.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/assign-prescriptions/images/1.gif
// module id = 13272
// module chunks = 0